import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'estimer-tarif',
  templateUrl: './estimer-tarif.component.html',
  styleUrls: ['./estimer-tarif.component.scss']
})
export class EstimerTarifComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
